import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedUsersPanel } from "./LinkedUsersPanel";
import MultiLinkedUserToClientList from "components/Picker/UserToClientPicker/MultiLinkedUserToClientList";

interface Props {
  bookkeepingId: number;
}

export const LinkedUsersToBookkeeping = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddUsers = async (newUsers: server.dto.UserToClientSmall[]) => {
    await window.CoreApi.Bookkeeping.LinkUserToClients({
      bookkeepingId: props.bookkeepingId,
      userToClientIds: newUsers.map(user => user.userToClientId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkUser = async (user: server.dto.UserToClientSmall) => {
    await window.CoreApi.Bookkeeping.UnlinkUserToClients({
      bookkeepingId: props.bookkeepingId,
      userToClientIds: [user.userToClientId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedUsersPanel<server.dto.ListUserToClientToBookkeepingLinkedUserToClientsInstruction>
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.SoUser.UsersThatCanAccess}
      noSelectionLabel={RESX.SoUser.AssignAtLeastOneUser}
      listFunc={window.CoreApi.Bookkeeping.PaginatedLinkedUserToClients}
      initialInstruction={{
        bookkeepingId: props.bookkeepingId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkUser}
      onAdd={() => setIsNewModalOpen(true)}
      onRemoveAll={() => window.CoreApi.Bookkeeping.UnlinkAllForBookkeeping({
        bookkeepingId: props.bookkeepingId,
      })}
      onAddAll={() => window.CoreApi.Bookkeeping.LinkAllForBookkeeping({
        bookkeepingId: props.bookkeepingId,
      })}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.SoUser.UsersThatCanAccess}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddUsers}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedUserToClientList
        initialInstruction={{
          bookkeepingId: props.bookkeepingId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.Bookkeeping.PaginatedLinkedUserToClients}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};